<template>
  <div class="draw" id="draw">
    <!-- DO NOT REMOVE WILL BREAK -->

    <div class="title">
      <h3 style="display: none;">{{ data.full_name }} {{ title }}</h3>
    </div>
    <b-row class="title">
      <b-col cols='8' :class="{homeTitleWidget : home == true}">
        <div class="title main TournamentTitle" >
          <template v-if="home == true">
            <span class="reportWidget_title">{{title}}</span>
          </template>
          <!-- <p :class="{WidgetStyle: home == true}">{{data.full_name}}</p> -->
          <template v-if="config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
            <template>
              <p :class="{WidgetStyle: home == true}">{{data.full_name}} <span v-if="home != true">- {{title}}</span></p>
            </template>
          </template>
          <template v-else>
            <p :class="{WidgetStyle: home == true}">{{data.full_name}}</p>
          </template>
        </div>
      </b-col>
      <b-col :class="{HomeHide: home == true}" cols="4">
        <div class="sponLogo">
          <!-- <i v-b-toggle.collapse-1 class="fa-solid fa-circle-info"></i> -->
          <template v-if="config.VUE_APP_ID == 'bvt' || config.VUE_APP_TOUR == 'let'">
            <img class="informationImg" v-b-toggle="'collapse-1'" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/Information.png">
          </template>
          <template v-else>
            <i
              v-b-toggle="'collapse-1'"
              class="fa-solid fa-circle-info"
            ></i>
          </template>
        </div>
      </b-col>
    </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <div :class="{reportsHide: home == false}" class="gradHome"></div>
    <!-- DO NOT REMOVE WILL BREAK -->
    <template v-if="home == false">
      <div v-if="data.alt_heading == 'Y'">
        <span class="AltText">
          <span v-if="data.alt_heading_text_1.length">{{
            data.alt_heading_text_1.length
          }}</span>
          <span v-if="data.alt_heading_text_2.length">{{
            data.alt_heading_text_2.length
          }}</span>
          <span v-if="data.alt_heading_text_3.length">{{
            data.alt_heading_text_3.length
          }}</span>
        </span>
      </div>
    </template>
    <table :class="{reportsHome : home == true}">
      <thead :class="{HomeHide: home == true}">
        <tr>
          <template v-if="tablePick === 'Draw'">
            <th v-if="data.match_play === 'Y'">
              Group
            </th>
            <th v-else>
              Match
            </th>
            <th class="Time">
              Time
            </th>
            <th v-if="data.multi_course === 'Y'">
              Course
            </th>
            <th>
              Tee
            </th>
            <th style="text-align: left;" class="playersName">
              Name
            </th>
          </template>
        </tr>
      </thead>
      <tbody v-cloak>
        <template>
          <tr
            v-for="(tabledata, index) in Eds"
            @click.stop="rowClicked(index)"
            :key="index"
            :class="{ drawNoborder: tablePick === 'Draw', homeTr: home == true }"
          >
            <template v-if="tablePick === 'Draw' && data.match_play === 'N'">
              <td :class="{homeposnum : home == true}">{{ tabledata[0].match }}</td>
              <td style="text-align:center">{{ tabledata[0].time }}</td>
              <template v-if="data.multi_course === 'Y'">
                <td>
                  <span :class="tabledata[0].course_colour">
                    {{ tabledata[0].course }}
                  </span>
                </td>
              </template>
              <template v-if="data.multi_course === 'Y'">
                <td class="multiTee">{{ tabledata[0].tee }}</td>
              </template>
              <template v-else>
                <td>{{ tabledata[0].tee }}</td>
              </template>
              <td class="playersName">
                <p
                  v-for="(player, index2) in tabledata"
                  :key="index2"
                  class="noMargin"
                >
                  <template v-if="player">
                    <a v-if="player.profile === 'Y'" :href="'/playerprofile/' + player.playerno" class="removeUnderLine">
                      {{ player.name }}
                      <span v-if="player.pro_ind === 'Am'">(a)</span>
                    </a>
                    <span v-else>
                      {{ player.name }}
                        <span v-if="player.pro_ind === 'Am'">(a)</span>
                    </span>
                  </template>
                  <span
                    v-if="showGender === 'Y'"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: player.gender === 'F',
                      male: player.gender === 'M'
                    }"
                    >•</span
                  >
                </p>
              </td>
            </template>
            <template v-if="tablePick === 'Draw' && data.match_play === 'Y'">
              <td>
                {{ tabledata[0].match }}
              </td>
              <td>
                {{ tabledata[0].time }}
              </td>
              <td>
                {{ tabledata[0].tee }}
              </td>
              <td class="playersName">
                <p
                  v-for="(player, index2) in tabledata"
                  :key="index2"
                  class="noMargin "
                >
                  <template v-if="player">
                    <a v-if="player.profile === 'Y'" :href="'/playerprofile/' + player.playerno">
                      {{ player.name }}
                      <span v-if="player.pro_ind === 'Am'">(a)</span>
                    </a>
                  </template>
                  <template v-else>
                    {{ player.name }}
                    <span v-if="player.pro_ind === 'Am'">(a)</span>
                  </template>
                  <span
                    v-if="showGender === 'Y'"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </p>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Information from "@ocs-software/vue-ocs/ocs/reports/information.vue";
import lodash from "lodash";
import _ from "lodash";
export default {
  name: "draw",
  components: [
    Information,
    lodash,
    _,
  ],
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "match",
    "showGender",
    "showmore",
    "develop",
    "show_info_web"
  ],
  data() {
    return {
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: [],
      win: "win"
    };
  },
  methods: {
    rowClicked: function(index) {
      if (this.tablePick === "Score" && this.clickedRow !== index)
        this.clickedRow = index;
      else this.clickedRow = -1;
    }
  },
  computed: {
    tablePick: function(picked) {
      if (this.title.includes("Draw")) picked = "Draw";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    Eds(reportData) {
      if (this.home === false && this.data.draw) {
        if (this.title.includes("Draw")) reportData = this.data.draw.draw_entry;
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = this.data.draw.draw_entry.slice(0,10);
              } else {
                reportData = this.data.draw.draw_entry;
              }
            } else {
              reportData = this.data.draw.draw_entry;
            }
        return _.groupBy(reportData, "match");
      } else {
        if (this.title.includes("Draw") && this.data.draw)
          if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
            reportData = this.data.draw.draw_entry;
          }
          else {
            reportData = this.data.draw.draw_entry.slice(0, 9);
          }
        return _.groupBy(reportData, "match");
      }
    }
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  }
};
</script>
